import { numberToPrettyString } from '@cian/utils';

import { IOfferCard } from '../../../types/card';

export function getTotalArea(offerCard: IOfferCard): string | undefined {
  if (offerCard.totalArea) {
    return numberToPrettyString(Number(offerCard.totalArea));
  }

  return undefined;
}
